<template>
    <header class="header">
        <div class="container">
            <nav class="navbar navbar-light justify-content-start px-0 pt-3 pb-3">
                <router-link to="/" class="navbar-brand mr-md-5 mr-3" replace>
                    <div v-if="brand.logo">
                        <img v-bind:src="brand.logo" class="brand-logo" />
                    </div>
                    <svg v-if="brand.logo == null" class="brand-logo" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 306 60" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h305.243v59.045h-305.243z" fill="none"/><g fill-rule="nonzero"><path d="m7.69 19.763c0-1.92-1.536-3.456-3.456-3.456s-3.456 1.536-3.456 3.456v23.168c0 1.92 1.536 3.456 3.456 3.456s3.456-1.536 3.456-3.456zm-3.456-6.912c2.688 0 4.16-1.536 4.16-4.032 0-2.944-1.472-4.224-4.16-4.224-2.624 0-4.096 1.28-4.096 4.224 0 2.496 1.472 4.032 4.096 4.032z"/><path d="m47.818 15.923c-4.352 0-7.104 1.408-9.152 4.16-1.6-2.496-4.224-4.16-9.472-4.16-4.288 0-6.976 1.984-8.192 3.84 0-1.92-1.536-3.456-3.456-3.456s-3.456 1.536-3.456 3.456v23.296c0 1.92 1.472 3.328 3.456 3.328s3.456-1.408 3.456-3.328v-14.272c0-3.776 1.6-6.592 6.4-6.592 4.16 0 5.632 2.496 5.632 6.144v14.72c0 1.92 1.408 3.328 3.456 3.328 1.92 0 3.456-1.408 3.456-3.328v-14.784c0-3.584 1.792-6.08 6.4-6.08 4.16 0 5.632 2.496 5.632 6.144v14.72c0 1.92 1.408 3.328 3.456 3.328 1.92 0 3.456-1.408 3.456-3.328v-16c0-5.568-2.368-11.136-11.072-11.136z"/><path d="m76.426 22.067c3.712 0 5.824 1.92 5.824 4.8v1.152h-8.384c-5.568 0-10.368 3.072-10.368 9.024 0 5.76 4.16 9.664 10.432 9.664 3.84 0 6.656-.96 8.384-3.712 0 1.856 1.536 3.392 3.392 3.392s3.392-1.536 3.392-3.392v-16.384c0-6.784-4.736-10.688-12.672-10.688-5.504 0-8.704 2.112-10.496 4.096-.576.64-.832 1.408-.832 2.112 0 1.664 1.344 3.008 3.008 3.008.768 0 1.28-.192 1.92-.64 1.6-1.152 3.584-2.432 6.4-2.432zm-.704 18.88c-3.584 0-5.312-1.472-5.312-3.904 0-2.304 1.536-3.648 4.352-3.648h7.488v1.792c0 3.584-3.136 5.76-6.528 5.76z"/><path d="m106.89 46.707c3.072 0 5.696-1.28 6.976-2.56v2.432c0 3.904-2.304 6.272-6.848 6.272-3.008 0-5.12-1.344-6.72-2.496-.768-.512-1.28-.768-2.048-.768-1.664 0-3.072 1.408-3.072 3.072 0 .832.32 1.472.64 1.856 2.176 2.624 6.016 4.224 11.2 4.224 9.472 0 13.824-4.992 13.824-13.824v-16.192c0-8.512-5.504-12.8-13.248-12.8-8.64 0-13.696 4.928-13.696 15.36s4.928 15.424 12.992 15.424zm7.04-9.152s-2.496 3.264-6.336 3.264c-4.352 0-6.848-3.2-6.848-9.536 0-6.272 2.432-9.472 6.848-9.472 3.712 0 6.336 2.496 6.336 6.912z"/><path d="m125.514 31.219c0 10.688 5.504 15.488 14.4 15.488 5.824 0 9.216-2.496 10.304-3.52.576-.512 1.088-1.344 1.088-2.368 0-1.664-1.344-3.008-3.008-3.008-.832 0-1.344.256-2.048.704-1.536 1.024-3.52 1.984-6.336 1.984-4.224 0-7.488-2.112-7.488-6.72h15.808c3.904 0 3.904-2.752 3.904-5.12 0-4.416-1.984-12.736-12.8-12.736-8.704 0-13.824 5.504-13.824 15.296zm13.824-9.408c4.16 0 5.952 3.072 5.952 6.208h-12.672c.32-4.096 3.008-6.208 6.72-6.208z"/><path d="m178.314 25.075s2.496-3.264 6.336-3.264c4.352 0 6.848 3.2 6.848 9.536 0 6.272-2.432 9.472-6.848 9.472-3.712 0-6.336-2.496-6.336-6.912zm7.04-9.152c-3.072 0-5.76 1.28-7.04 2.56v-14.72c0-1.92-1.536-3.456-3.456-3.456s-3.456 1.536-3.456 3.456v30.144c0 8.512 5.504 12.8 13.248 12.8 8.64 0 13.696-4.928 13.696-15.36s-4.928-15.424-12.992-15.424z"/><path d="m214.922 22.067c3.712 0 5.824 1.92 5.824 4.8v1.152h-8.384c-5.568 0-10.368 3.072-10.368 9.024 0 5.76 4.16 9.664 10.432 9.664 3.84 0 6.656-.96 8.384-3.712 0 1.856 1.536 3.392 3.392 3.392s3.392-1.536 3.392-3.392v-16.384c0-6.784-4.736-10.688-12.672-10.688-5.504 0-8.704 2.112-10.496 4.096-.576.64-.832 1.408-.832 2.112 0 1.664 1.344 3.008 3.008 3.008.768 0 1.28-.192 1.92-.64 1.6-1.152 3.584-2.432 6.4-2.432zm-.704 18.88c-3.584 0-5.312-1.472-5.312-3.904 0-2.304 1.536-3.648 4.352-3.648h7.488v1.792c0 3.584-3.136 5.76-6.528 5.76z"/><path d="m248.778 15.923c-4.288 0-6.976 1.984-8.192 3.84 0-1.92-1.536-3.456-3.456-3.456s-3.456 1.536-3.456 3.456v23.296c0 1.92 1.472 3.328 3.456 3.328s3.456-1.408 3.456-3.328v-14.272c0-3.776 1.6-6.592 6.4-6.592 4.16 0 5.632 2.496 5.632 6.144v14.72c0 1.92 1.408 3.328 3.456 3.328 1.92 0 3.456-1.408 3.456-3.328v-16c0-5.568-2.048-11.136-10.752-11.136z"/><path d="m287.114 46.387c1.856 0 3.328-1.472 3.328-3.328 0-.64-.192-1.344-.704-2.048l-9.408-12.352 8.384-6.4c.832-.64 1.28-1.664 1.28-2.624 0-1.856-1.472-3.328-3.328-3.328-.768 0-1.408.192-2.24.832l-11.584 9.088v-22.592c0-1.92-1.536-3.328-3.456-3.328-1.984 0-3.456 1.408-3.456 3.328v39.424c0 1.92 1.472 3.328 3.456 3.328 1.92 0 3.456-1.408 3.456-3.328v-9.216l2.048-1.6 9.536 12.8c.576.768 1.472 1.344 2.688 1.344z"/><path d="m300.945 46.3c2.688 0 4.16-1.344 4.16-4.16 0-2.88-1.472-4.288-4.16-4.288s-4.224 1.408-4.224 4.288c0 2.816 1.536 4.16 4.224 4.16z"/></g></svg>
                </router-link>
                <div class="search-wrapper mr-0 mr-sm-3">
                    <input v-if="is_account == false" v-on:keyup="search" v-model="search_value" class="search-input form-control input-search border-0 pr-3" name="q" type="text" size="40" ref="search" placeholder="Search for image" />
                </div>
                <div v-if="cart_ids.length > 0" class="download-counter">
                    <div class="dropdown">
                        <button type="button" class="counter-dropdown btn btn-secondary dropdown-toggle" data-toggle="dropdown">
                            {{ cart_total }}
                        </button>
                    </div>
                    <div v-if="cart.items.length > 0" class="dropdown-menu counter-cart">
                        <div v-for="c in cart.items" :key="c.id">
                            <span class="dropdown-item counter-cart-item"><span class="cart-image-title">{{ c.name }}</span><span v-on:click="remove_from_cart(c.id)" class="remove"><svg viewBox="0 0 22.266 26.719"><path d="m98.227 87.757a2.974 2.974 0 0 0 2.969 2.962h11.874a2.974 2.974 0 0 0 2.969-2.962v-17.077h-17.812zm20.039-21.53h-5.566l-1.864-2.227h-7.406l-1.864 2.227h-5.566v2.227h22.266z" transform="translate(-96 -64)"/></svg></span></span>
                        </div>
                    </div>
                </div>
                <div v-if="cart_ids.length > 0" v-on:click="download_zip" class="btn-circle-download" v-bind:class="{load: download_mark_loading, done: download_mark_loading_done}">
                    <!-- <svg id="arrow" width="14px" height="20px" viewBox="17 14 14 20"><path d="M24,15 L24,32"></path><polyline points="30 27 24 33 18 27"></polyline></svg> -->
                    <svg id="arrow" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.41421" viewBox="0 0 495 461" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(.967314 0 0 .970128 10.1426 -14.8808)"><path d="m-10.485 15.339h511.07v474.561h-511.07z" fill="none"/><g fill-rule="nonzero"><path d="m468.3 255.8.2-.2c.3-.4.6-.7.8-1.1.1-.1.1-.2.2-.3.2-.4.5-.8.7-1.2 0-.1.1-.2.1-.2.2-.4.4-.8.6-1.3 0-.1 0-.1.1-.2.2-.4.3-.9.5-1.4 0-.1 0-.2.1-.2.1-.5.3-.9.3-1.4 0-.2 0-.3.1-.5.1-.4.1-.8.2-1.2.1-.6.1-1.1.1-1.7s0-1.1-.1-1.7c0-.4-.1-.8-.2-1.2 0-.2 0-.3-.1-.5-.1-.5-.2-.9-.3-1.4 0-.1 0-.2-.1-.2-.1-.5-.3-.9-.5-1.4 0-.1 0-.1-.1-.2-.2-.4-.4-.9-.6-1.3 0-.1-.1-.2-.1-.2-.2-.4-.4-.8-.7-1.2-.1-.1-.1-.2-.2-.3-.3-.4-.5-.8-.8-1.1-.1-.1-.1-.1-.2-.2-.4-.4-.7-.9-1.2-1.3l-98.9-98.8c-6.7-6.7-17.6-6.7-24.3 0s-6.7 17.6 0 24.3l69.6 69.6h-276.7c-9.5 0-17.2 7.7-17.2 17.1 0 9.5 7.7 17.2 17.2 17.2h276.8l-69.1 69.1c-6.7 6.7-6.7 17.6 0 24.3 3.3 3.3 7.7 5 12.1 5s8.8-1.7 12.1-5l98.3-98.3c.5-.6.9-1 1.3-1.4z" transform="matrix(0 1.03079 1.03379 0 -8.17709 -105.014)"/><path d="m110.7 34.3h128c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2h-128c-51.3 0-93.1 41.8-93.1 93.1v303.7c0 51.3 41.8 93.1 93.1 93.1h125.9c9.5 0 17.2-7.7 17.2-17.1 0-9.5-7.7-17.2-17.2-17.2h-125.9c-32.4 0-58.8-26.4-58.8-58.8v-303.7c.1-32.5 26.4-58.8 58.8-58.8z" transform="matrix(0 -1.03079 1.03379 0 -8.17709 505.112)"/></g></g></svg>
                    <svg id="check" viewBox="13 17 21 15"><polyline points="32.5 18.5 20 31 14.5 25.5"></polyline></svg>
                    <svg id="border" viewBox="0 0 48 48"><path d="M24,1 L24,1 L24,1 C36.7025492,1 47,11.2974508 47,24 L47,24 L47,24 C47,36.7025492 36.7025492,47 24,47 L24,47 L24,47 C11.2974508,47 1,36.7025492 1,24 L1,24 L1,24 C1,11.2974508 11.2974508,1 24,1 L24,1 Z"></path></svg>
                </div>
                <div v-if="user.name" class="user dropdown ml-3">
                    <button class="btn btn-secondary dropdown-toggle d-flex align-items-center pl-0 pr-0" type="button" id="userdropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <svg class="mr-0 mr-sm-2" viewBox="0 0 512 512"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"/></svg>
                        <span class="d-none d-sm-block">{{ user.name }}</span>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="userdropdown">
                        <div class="d-flex flex-column">
                            <router-link class="dropdown-item" :to="{name: 'my-account'}">My account</router-link>
                            <router-link v-if="is_admin" class="dropdown-item" :to="{name: 'accounts'}">Accounts</router-link>
                            <router-link v-if="is_admin" class="dropdown-item" :to="{name: 'digital-assets'}">Digital assets</router-link>
                            <router-link v-if="is_admin" class="dropdown-item" :to="{name: 'branding'}">Branding</router-link>
                            <span class="dropdown-item" v-on:click="logout()">Logout</span>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
        <div v-if="downloading" class="download-loader loading"></div>
    </header>
</template>

<script>
    import {event} from 'vue-analytics';

    /* eslint-disable */
    export default {
        data () {
            return {
                is_account: false,
                brand: {
                    logo: false
                },
                user: {
                    name: null
                },
                search_value: null,
                download_mark_loading: false,
                download_mark_loading_done: false
            }
        },
        computed: {
            is_admin () {
                return this.$store.state.is_admin;
            },
            cart () {
                return this.$store.state.cart;
            },
            cart_ids () {
                return this.$store.getters.cart_ids;
            },
            cart_total () {
                return this.$store.getters.cart_total;
            },
            downloading () {
                return this.$store.state.downloading;
            }
        },
        watch: {
            $route (to) {
                if (!to.query.search) {
                    this.search_value = null;
                }
            }
        },
        mounted () {
            this.load_brand();
            this.load_user();
            this.$store.commit('load_cart');
            if (this.$route.path.includes('/account/')) {
                this.is_account = true;
            }
            if (this.$route.query.search) {
                this.search_value = this.$route.query.search;
            }
        },
        methods: {
            load_brand () {
                axios.get(process.env.VUE_APP_API_URL + '/api/brand/')
                    .then(response => (
                        this.brand.logo = response.data['brand_logo']
                    ))
            },
            load_user () {
                axios.get(process.env.VUE_APP_API_URL + '/api/user/')
                    .then(response => (
                        this.user.name = response.data['firstname']
                    ))
            },
            logout () {
                this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push({path: '/auth/login'})
                });
            },
            search (input) {
                if (input.target.value) {
                    const current_path = this.$route.path;
                    const search_value = input.target.value;
                    this.$router.push({path: current_path, query: {search: search_value}});
                }
                else {
                    const current_path = this.$route.path;
                    this.$router.push({path: current_path});
                }
            },
            remove_from_cart(id) {
                if (this.$cookies.get('cart')) {
                    var items = this.$cookies.get('cart').items;

                    for (var i = 0; i < items.length; i++) {
                        if(items[i].id == id) {
                            items.splice(i, 1);
                        }
                    }

                    var cart = {items: items};
                    this.$cookies.set('cart', cart);

                    this.$store.commit('load_cart');
                }
            },
            download_zip() {
                if (this.cart_ids.length > 0) {
                    this.download_mark_loading = true;
                    var ids = this.cart_ids.join(',');

                    var names = this.cart.items;

                    axios.post(process.env.VUE_APP_API_URL + '/api/create/zip/' + ids)
                    .then(response => (
                        this.js_file_download(response.data['name'], response.data['download_url'])
                    ))

                    setTimeout(()=>{this.download_mark_loading_done = true;}, 1000);
                    setTimeout(()=>{this.download_mark_loading = false;this.download_mark_loading_done = false;this.$cookies.remove('cart');this.$store.commit('load_cart');}, 5000);

                    names.forEach(function(element) {
                        event('image', 'download', element.name, 1);
                    });
                }
            },
            js_file_download(name, file_url) {
                var tempLink = document.createElement('a');
                tempLink.style.display = 'none';
                tempLink.href = file_url;
                tempLink.setAttribute('download', name);

                var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                // Safari thinks _blank anchor are pop ups. We only want to set _blank
                // target if the browser does not support the HTML5 download attribute.
                // This allows you to download files in desktop safari if pop up blocking
                // is enabled.
                if (typeof tempLink.download === 'undefined' || iOS === true) {
                    tempLink.setAttribute('target', '_blank');
                }

                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
            }
        }
    }
</script>
